import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Сумма пополнения", -1)
const _hoisted_4 = ["min"]
const _hoisted_5 = { class: "form-text" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "payment-form" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", null, "После нажатия \"Пополнить\" вы будете перенаправлены на платежную систему ЮКасса!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_g_text = _resolveComponent("g-text")!
  const _component_base_popup = _resolveComponent("base-popup")!

  return (_openBlock(), _createBlock(_component_base_popup, {
    title: "Пополнить счет",
    onClose: _ctx.close
  }, {
    body: _withCtx(() => [
      (!_ctx.loadForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getPayUrl && _ctx.getPayUrl(...args)), ["prevent"]))
            }, [
              _createVNode(_component_g_text, {
                label: "Почта",
                modelValue: _ctx.auth.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.auth.email) = $event)),
                required: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "number",
                  min: _ctx.min_replenish,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amount) = $event)),
                  required: ""
                }, null, 8, _hoisted_4), [
                  [_vModelText, _ctx.amount]
                ]),
                _createElementVNode("div", _hoisted_5, "Минимальная сумма пополнения " + _toDisplayString(_ctx.min_replenish) + "₽", 1)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-sm btn-success",
                disabled: _ctx.amount < _ctx.min_replenish
              }, " Пополнить ", 8, _hoisted_6)
            ], 32)
          ]))
        : _createCommentVNode("", true),
      _hoisted_7
    ]),
    footer: _withCtx(() => [
      _hoisted_8
    ]),
    _: 1
  }, 8, ["onClose"]))
}